module.exports = __webpack_public_path__ + "static/media/credit-card-icon.b36bc5af.svg";